module.exports = __webpack_public_path__ + "static/media/remove-icon.efb9b19b.svg";